import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/styles'
import { Grid, FormControl, TextField, CircularProgress } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  item: {
    marginTop: theme.spacing(1),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  quesitoGrupo: {
    marginBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  inputQuesito: {
    fontWeight: 'bold',
  },
  semQuesitos: {
    padding: theme.spacing(4),
  },
}))

export const Quesitos = (props) => {
  const { formState, setFormState, processandoExame, exame } = props

  const classes = useStyles()

  useEffect(() => {
    if (exame) {
      setFormState({
        ...formState,
        values: {
          respostasQuesitos: exame.respostasQuesitos,
        },
      })
    }
   
  }, [])

  const handleChangeRespostaQuesito = (value, idRespostaQuesito) => {
    const novaListaQuesitos = formState.values.respostasQuesitos.map((respostaQuesito) => {
      const novaResposta = respostaQuesito
      if (respostaQuesito.id === idRespostaQuesito) {
        novaResposta.resposta = value
      }
      return novaResposta
    })
    setFormState({
      ...formState,
      values: {
        respostasQuesitos: novaListaQuesitos,
      },
    })
  }

  return processandoExame ? (
    <div className={classes.carregando}>
      <CircularProgress disableShrink />
    </div>
  ) : (
    <div>
      {formState.values && formState.values.respostasQuesitos ? (
        formState.values.respostasQuesitos.map((respostaQuesito, index) => (
          <div className={classes.quesitoGrupo}>
            <Grid
              className={classes.fieldGroup}
              alignItems="center"
              container
              justify="space-between"
            >
              <FormControl
                key={respostaQuesito}
                style={{
                  minWidth: '100%',
                  maxWidth: '100%',
                }}
              >
                <TextField
                  fullWidth
                  multiline
                  disabled
                  rows={1}
                  className={classes.inputQuesito}
                  name={respostaQuesito.quesito.quesito}
                  value={respostaQuesito.quesito.quesito || ''}
                />
              </FormControl>
            </Grid>
            <Grid
              className={classes.fieldGroup}
              alignItems="center"
              container
              justify="space-between"
            >
              <FormControl
                key={respostaQuesito}
                style={{
                  minWidth: '100%',
                  maxWidth: '100%',
                }}
              >
                <TextField
                  fullWidth
                  multiline
                  rows={2}
                  name={respostaQuesito.quesito.quesito}
                  onChange={(e) => {
                    handleChangeRespostaQuesito(e.target.value, respostaQuesito.id)
                  }}
                  value={
                    formState.values.respostasQuesitos[index].resposta
                      ? formState.values.respostasQuesitos[index].resposta
                      : ''
                  }
                />
              </FormControl>
            </Grid>
          </div>
        ))
      ) : (
        <div className={classes.semQuesitos}>
          Não existem quesitos cadastrados para esta solicitação de exame
        </div>
      )}
    </div>
  )
}
